import { createAsyncThunk } from '@reduxjs/toolkit'
import SquadMate from './squad-mate-model'
import {
  delete_squadMate,
  load_squadMates,
  store_squadMate,
} from './squadMate-service'

export const LoadSquadMatesAsync = createAsyncThunk<any, any>(
  'composer/load/squadMate',
  async (params: { uid: string }) => {
    return await load_squadMates(params)
  },
)

export const CreateSquadMateAsync = createAsyncThunk<any, any>(
  'composer/create/squadMate',
  async (params: SquadMate) => {
    return await store_squadMate(params)
  },
)

export const DeleteSquadMateAsync = createAsyncThunk<any, any>(
  'composer/delete/squadMate',
  async (params) => {
    return await delete_squadMate(params)
  },
)
